import { render } from "./RadioButton.vue?vue&type=template&id=5d8ba747&scoped=true"
import script from "./RadioButton.vue?vue&type=script&lang=ts"
export * from "./RadioButton.vue?vue&type=script&lang=ts"

import "./RadioButton.vue?vue&type=style&index=0&id=5d8ba747&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d8ba747"

export default script